import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { Platform, TextInputProps } from 'react-native';

export interface BlankTextInputProps extends TextInputProps {
  autosize?: boolean;
}

export const BlankTextInput = ({
  autosize,
  style,
  value,
  onChangeText,
  ...props
}: BlankTextInputProps) => {
  const [internalValue, setInternalValue] = React.useState<string>('');

  const textInputWidth = React.useMemo(
    () => Math.round(0.9 * internalValue?.length ?? 0) + 'ch',
    [internalValue?.length]
  );

  React.useEffect(() => setInternalValue(value ?? ''), [value]);

  return (
    <StyledTextInput
      value={internalValue}
      onChangeText={(text) => {
        setInternalValue(text);
        onChangeText?.(text);
      }}
      style={[
        autosize &&
          Platform.OS === 'web' && {
            width: textInputWidth,
          },
        style,
      ]}
      {...props}
    />
  );
};

const StyledTextInput = styled.TextInput`
  border-bottom-width: 2px;
  min-width: 20px;
  margin-left: 5px;
  padding-horizontal: 2px;
  padding-vertical: 0;
  color: ${({ theme }) => theme.color.dark1};
  border-color: ${({ theme }) => theme.color.dark1};
  font-family: ${({ theme }) => theme.secondaryFont.regular.fontFamily};
`;
